import React, { useState } from 'react';
import {
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Box,
  FormControl
} from '@mui/material';
import { AddTestCycleFormData, TestCycle } from '../types/test-cycle';
import { useNavigate } from 'react-router-dom';
import TopBar from '../components/TopBar';

interface AddTestCycleProps {
  onLogout: () => void;
}

const AddTestCyclePage = ({ onLogout }: AddTestCycleProps): React.JSX.Element => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState<AddTestCycleFormData>({
    numerator: 0,
    denominator: 0,
    testedChange: '',
    comment: '',
    interventionsTaken: '',
    challengesExperienced: '',
    lessonsLearned: '',
    team: [],
    updateTeam: false,
    actionPlan: [],
    sharedInForum: false
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const testCycle: TestCycle = {
      id: crypto.randomUUID(),
      projectId: '', // Will be set when adding to a specific project
      ...formData,
      createdAt: new Date().toISOString()
    };
    // TODO: Save to storage
    navigate(-1);
  };

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <TopBar onLogout={onLogout} />
      </Box>
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper sx={{ p: 4 }} elevation={1}>
        <Typography variant="h4" gutterBottom>
          Update Progress
        </Typography>
        <form onSubmit={handleSubmit}>
          <Box display="flex" flexDirection="column" gap={3}>
            <Box display="flex" gap={2}>
              <TextField
                label="Numerator"
                type="number"
                value={formData.numerator}
                onChange={(e) => setFormData(prev => ({ ...prev, numerator: parseInt(e.target.value) || 0 }))}
                fullWidth
                required
              />
              <TextField
                label="Denominator"
                type="number"
                value={formData.denominator}
                onChange={(e) => setFormData(prev => ({ ...prev, denominator: parseInt(e.target.value) || 0 }))}
                fullWidth
                required
              />
            </Box>
            <TextField
              label="Tested Change"
              value={formData.testedChange}
              onChange={(e) => setFormData(prev => ({ ...prev, testedChange: e.target.value }))}
              fullWidth
              multiline
              rows={3}
              required
            />
            <TextField
              label="Comment"
              value={formData.comment}
              onChange={(e) => setFormData(prev => ({ ...prev, comment: e.target.value }))}
              fullWidth
              multiline
              rows={2}
            />
            <Box display="flex" gap={2} justifyContent="flex-end">
              <Button onClick={() => navigate(-1)}>
                Cancel
              </Button>
              <Button type="submit" variant="contained" color="primary">
              Update Progress
              </Button>
            </Box>
          </Box>
        </form>
      </Paper>
    </Container>
    </>
  );
};

export default AddTestCyclePage;
